import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Card,
    CardBody,
    Button,
    CustomInput,
    InputGroup,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_Update_HideStats } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';

export default function HideStat_topic({ propertyId, property, isSuccess, setIsSuccess, clickEnd, getdata, stepStatusMap, stepCreate, userName, id }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [hasChanged, setHasChanged] = useState(false);
    const isUpdated = stepStatusMap?.hidestate_topic === "UpdatedOrCreated";
    const [rateData, setRateData] = useState({
        averageDailyRate: 0,
        averageDailyRateUSD: 0,
        averageHourlyWageRate: 0,
        averageHourlyWageRateUSD: 0,
    });
    const [topics, setTopics] = useState(property?.topics || []);
    const handleAddEmails = () => {
        let lst = [...topics];
        lst.push('');
        setTopics(lst);
    };

    const handlRemove = (e) =>
        setTopics(topics.filter((f, index) => index !== e));

    useEffect(() => {
        if (property !== undefined) {
            if (property?.averageDailyRate !== null && property?.averageHourlyWageRate !== null && property?.averageDailyRateUSD !== null && property?.averageHourlyWageRateUSD !== null) {
                setRateData({
                    averageDailyRate: property?.averageDailyRate || 0,
                    averageDailyRateUSD: property?.averageDailyRateUSD || 0,
                    averageHourlyWageRate: property?.averageHourlyWageRate || 0,
                    averageHourlyWageRateUSD: property?.averageHourlyWageRateUSD || 0,
                });
            }
        }
    }, [property]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRateData({
            ...rateData,
            [name]: parseFloat(value),
        });
        setHasChanged(true);
    };
    const handleChangeTopic = (e, index) => {
        let lst = [...topics];
        lst[index] = e.target.value;
        setTopics(lst);
        setHasChanged(true);
    };
    const handleSave = async () => {
        const body = {
            ...rateData,
            topics: topics,
            updater: 'Admin',
        };

        try {

            const res = await AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_HideStats}/${propertyId}`,
                data: body,
            });

            if (
                res.data.HttpStatusCode !== undefined &&
                res.data.HttpStatusCode === 400 &&
                res.data.Messages !== undefined &&
                res.data.Messages !== null &&
                res.data.Messages.length > 0
            ) {
                setMsg(res.data.Messages);
                setOpen(true);
                return;
            }

            NotificationManager.success(
                '',
                'Insights updated successfully',
                3000
            );

            const payload = {
                onboardSessionId: id,
                stepName: "insights",
                status: "UpdatedOrCreated",
                creator: userName,
                modifiedBy: "Dashboard",
                insightsConfig: {
                    averageDailyRoomRate: rateData.averageDailyRate?.toString(),
                    averageDailyRoomRateUsd: rateData.averageDailyRateUSD?.toString(),
                    averageHourlyWageRate: rateData.averageHourlyWageRate?.toString(),
                    averageHourlyWageRateUsd: rateData.averageHourlyWageRateUSD?.toString(),
                    insights: ''
                }
            };

            await stepCreate(payload);

            setIsSuccess(true);
            setHasChanged(false);

            await getdata(id);

        } catch (error) {

            NotificationManager.error(
                'Update failed',
                '',
                3000
            );

            console.error(error);
        }
    };
    const handleNotNow = async () => {
        await stepCreate({
            onboardSessionId: id,
            stepName: "insights",
            status: "Skipped",
            creator: userName,
            modifiedBy: "Dashboard",
        });

        clickEnd();
    };
    console.log('suc', isSuccess)
    return (
        <Fragment>
            <div className="mb-4 mt-4 ml-4">
                <Row className='mr-4'>
                    <Colxx sm={12} className="mb-2 ">
                        <h6>Insights</h6>
                        <Row className="">
                            <Colxx md={6} className="mt-3">
                                <Label>Average Daily Room Rate
                                    {property?.currency ? ` (${property.currency})` : ''}
                                </Label>
                                <Input className=' input_sty'
                                    type="number"
                                    min={0}
                                    name="averageDailyRate"
                                    value={rateData.averageDailyRate}
                                    onChange={handleChange}
                                />
                            </Colxx>
                            <Colxx md={6} className="mt-3">
                                <Label>Average Daily Room Rate (USD)</Label>
                                <Input className=' input_sty'
                                    type="number"
                                    min={0}
                                    name="averageDailyRateUSD"
                                    value={rateData.averageDailyRateUSD}
                                    onChange={handleChange}
                                />
                            </Colxx>

                            <Colxx md={6} className="mt-3">
                                <Label>Average Hourly Wage Rate
                                    {property?.currency ? ` (${property.currency})` : ''}
                                </Label>
                                <Input className=' input_sty'
                                    type="number"
                                    min={0}
                                    name="averageHourlyWageRate"
                                    value={rateData.averageHourlyWageRate}
                                    onChange={handleChange}
                                />
                            </Colxx>

                            <Colxx md={6} className="mt-3">
                                <Label>Average Hourly Wage Rate (USD)</Label>
                                <Input className=' input_sty'
                                    type="number"
                                    min={0}
                                    name="averageHourlyWageRateUSD"
                                    value={rateData.averageHourlyWageRateUSD}
                                    onChange={handleChange}
                                />
                            </Colxx>
                            <Colxx md={12}>
                                <div className="text-left mb-2 mt-4">
                                    <h6>
                                        {' '}
                                        <IntlMessages id="content.topics" />{' '}
                                    </h6>
                                </div>

                                {topics.map((m, index) => (
                                    <div className="row mt-2 mb-2">
                                        <div className="col-md-9">
                                            <InputGroup>
                                                <Input
                                                    value={m}
                                                    type="text"
                                                    onChange={(e) => handleChangeTopic(e, index)}
                                                ></Input>
                                            </InputGroup>
                                        </div>
                                        <div className="col-md-3">
                                            <Button
                                                color="danger"
                                                outline
                                                size="xs"
                                                onClick={() => handlRemove(index)}
                                            >
                                                -
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                                <div className="row mt-1 ml-2 mb-3">
                                    <div className="d-flex w-100">
                                        <Button
                                            color="primary"
                                            outline
                                            size="xs"
                                            onClick={handleAddEmails}
                                        >
                                            + Add Topic
                                        </Button>
                                    </div>
                                </div>
                            </Colxx>
                        </Row>
                    </Colxx></Row>
                <Colxx xxs="12" className="mb-4 mt-4 text-right">
                    {isUpdated && !hasChanged ? (
                        <Button
                            color="primary"
                            size="lg"
                            outline
                            className=" mr-1"
                            onClick={clickEnd}
                        >
                            Next
                        </Button>
                    ) : (
                        <div className='widget-wrap'>

                            <Button
                                color="primary"
                                size="lg"
                                outline
                                onClick={handleSave}
                            >
                                Update Insight
                            </Button>
                            <h6
                                style={{ display: 'flex' }}
                                className="ml-4 not-now"
                                onClick={handleNotNow}
                            >
                                Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M60 25 H100 L90 15 M100 25 L90 35"
                                        fill="none"
                                        stroke="grey"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                            </h6>
                        </div>
                    )
                    }
                </Colxx>
            </div>
            <Validation
                open={open}
                messages={msg}
                toggle={() => {
                    setOpen(!open);
                }}
            ></Validation>
        </Fragment>
    );
}
